import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const Countries = () => {
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 600,
    autoplaySpeed: 3000,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  const countries = [
    { name: "Australia", flag: "flag-1.jpg" },
    { name: "Germany", flag: "flag-2.jpg" },
    { name: "Brazil", flag: "flag-3.jpg" },
    { name: "Russia", flag: "flag-4.jpg" },
    { name: "England", flag: "flag-5.jpg" }
  ];

  return (
    <section className="countries-section-two">
      <div className="auto-container">
        <div
          className="bg-image"
          style={{ backgroundImage: 'url(/assets/images/background/2.jpg)' }}
        ></div>

        <div className="sec-title text-center light">
          <span className="sub-title">Countries we offer</span>
          <h2>
            Countries We Support <br /> for Immigration.
          </h2>
        </div>

        <div className="carousel-outer">
          <Slider {...settings} className="countries-carousel">
            {countries.map((country, index) => (
              <div className="country-block-two" key={index}>
                <div className="inner-box">
                  <div className="flag">
                    <img
                      src={`/assets/images/resource/${country.flag}`}
                      alt={`${country.name} Flag`}
                    />
                  </div>
                  <div className="info">
                    <h5 className="title">
                      <a href="page-country-details.html">{country.name}</a>
                    </h5>
                    <div className="text">
                      Fusce pretium sem is the eget mattis.
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Countries;